/**
 * Object LazyLoadInit = { init: ... } structure did not work for requestAnimationFrame
 * So used this structure
 *
 * Make this this script is on both js-front and js-account!
 *
 * window.onload is required to make sure googletag.pubads().getSlots() is set
 */

var googleTagInterval;

class LazyLoadAds {
  constructor () {
    window.onload = () => {

      // do nothing if ads are not enabled
      if ( !window.adsEnabled ) {
        console.log('Ads disabled per environment')
        return
      }

      googleTagInterval = window.setInterval(() => {
        // console.log('LazyLoadAds: checking...')
        if ( window.googletagEnable ) {
          this.initScroll()
          this.clearGoogleTagInterval()
        }
      }, 1000)
    }
  }

  clearGoogleTagInterval () {
    // console.log('LazyLoadAds: clear interval')
    window.clearInterval(googleTagInterval)
  }

  initScroll () {
    this.adQueue = []

    // load all defined ads into adQueue
    if ( window.googletag.pubadsReady ) {
      var slots = window.googletag.pubads().getSlots()

      for (var i in window.googletag.pubads().getSlots()) {
        let slotId = '';

        if (typeof slots[i].getSlotId === 'function') {
          slotId = slots[i].getSlotId().getDomId();
        }

        // No lazy-load for OOP ads
        if (slotId === 'dfp-oop') {
          // but we have to delay it to make sure dfp and blueconic are loaded
          setTimeout(() => {
            this.showAd('dfp-oop')
          }, 3000)
          continue
        }

        var tagElement = document.querySelector('#' + slotId)
        if (!tagElement) {
          continue
        }
        this.adQueue.push(tagElement)
      }
    }

    this.raf = window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      window.oRequestAnimationFrame
    this.lastScrollTop = window.pageYOffset
    this.scroll() // do first scroll on page load
    if (this.raf) {
      this.loop()
    }
  }

  scroll () {
    if (this.adQueue.length === 0) {
      // all elements shown
      return
    }

    for (var eId in this.adQueue) {
      var e = this.adQueue[eId]
      if (this.isVisible(e)) {
        // Special behavior only for ad-dfp--search ads
        // Do not show them if not visible
        // console.log(e.parentNode.classList)
        if (e.parentNode.classList.contains('ad-dfp--search') && !e.parentNode.classList.contains('banner-footer')) {
          // Attached to <main> then not visible
          // See SearchPageAds.saveAdElements()
          if (e.parentElement.parentElement.tagName === 'MAIN') {
            continue
          }
        }

        var delay = e.dataset.delay
        this.adQueue.splice(eId, 1)
        if (delay > 0) {
          setTimeout(() => this.showAd(e.id), delay)
        } else {
          this.showAd(e.id)
        }
      }
    }
  }

  isVisible (elm) {
    // AM-1387
    if (!elm || typeof elm['getBoundingClientRect'] !== 'function') {
      return false
    }
    var rect = elm.getBoundingClientRect()
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight) +
      300 // make the viewHeight 300px taller to trigger `true` when it's about to be visible
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
  }

  showAd (slotId) {

    let slotObject = window.googletag.pubads().getSlots().find(slot => slot.getSlotId().getDomId() === slotId);
    let dfpAdUnit = slotObject.getAdUnitPath();

    if (slotObject.getSizes().length === 0) return false;
    let slotSizes = slotObject.getSizes().map(s => s.o + 'x' + s.m);

    let id = slotObject.getSlotId().getId();

    if (dfpAdUnit && slotSizes.length > 0) {
      let slotConfig = [dfpAdUnit, slotSizes, id]

      OX.dfp_bidder.addSlots(
        [slotConfig],
        function () {
          oxhbjs.setOxTargeting([slotObject])
          window.googletag.pubads().refresh([slotObject], {changeCorrelator: false})
        }
      )
    }
  }

  // requestAnimationFrame must be called in the window context. So we use "instance" instead of "this" to ensure
  // we are pulling properties and methods from LazyLoadAds
  loop () {
    var scrollTop = window.pageYOffset
    if (lazyLoadAdsInstance.lastScrollTop === scrollTop) {
      lazyLoadAdsInstance.raf.call(window, lazyLoadAdsInstance.loop)
      return
    }
    lazyLoadAdsInstance.lastScrollTop = scrollTop
    lazyLoadAdsInstance.scroll()
    lazyLoadAdsInstance.raf.call(window, lazyLoadAdsInstance.loop)
  }

  /**
   * Refresh If Shown
   *
   * Used by Search Results to refresh ads when search parameters change
   *
   * @param slotId
   */
  refreshIfShown (slotId) {
    // do nothing if ads are not enabled
    if (!window.adsEnabled) {
      return
    }
    // did i initiate?
    if (!window.googletag || !window.googletag.pubadsReady || !this.adQueue) {
      return
    }
    var slotObject = window.googletag.pubads().getSlots().find(slot => slot.getSlotId().getDomId() === slotId);
    if (typeof slotObject === 'undefined') {
      return
    }
    // dont refresh ad that has not been loaded through lazy load yet
    if (this.adQueue.indexOf(slotId) !== -1) {
      return
    }
    this.showAd(slotId)
  }
}

// load it here
let lazyLoadAdsInstance
if (typeof lazyLoadAdsInstance === 'undefined') {
  lazyLoadAdsInstance = new LazyLoadAds()
}

export default lazyLoadAdsInstance
